import { mapGetters } from 'vuex'

import LocationsService from '@/services/LocationsService'
import CategoriesService from '@/services/CategoriesService'
import TransitService from '@/services/TransitService'
import CampusesService from '@/services/CampusesService'
// import ToursService from '@/services/ToursService'

import LocationForm from '@/components/admin/collections/forms/LocationForm'
import CategoryForm from '@/components/admin/collections/forms/CategoryForm'
import TransitStopForm from '@/components/admin/collections/forms/TransitStopForm'
import CampusForm from '@/components/admin/collections/forms/CampusForm'
// import TourForm from '@/components/admin/collections/forms/TourForm'

export default {
  computed: {
    ...mapGetters([
      'campuses',
      'transitStops',
      'categories',
      'locations',
      'tours'
    ]),
    items () {
      let store = []

      switch (this.name) {
        case 'locations':
          store = this.locations
          break
        case 'categories':
          store = this.categories
          break
        case 'transitstops':
          store = this.transitStops
          break
        case 'campuses':
          store = this.campuses
          break
        case 'tours':
          store = this.tours
          break
        default:
          return []
      }

      return store
    }
  },
  data () {
    return {
      collections: {
        locations: {
          text: 'Locations',
          icon: 'fa-building',
          headers: [
            { text: 'Code', value: 'code' },
            { text: 'Name', value: 'name' },
            { text: 'Category', value: 'category' },
            { text: 'Campus', value: 'campus' },
            { text: '', value: 'modify', align: 'right', sortable: false }
          ],
          form: LocationForm,
          table: '',
          delete: async (id) => {
            const response = await LocationsService.deleteLocation(id)
            return response
          }
        },
        categories: {
          text: 'Categories',
          icon: 'fa-list',
          headers: [
            { text: 'Name', value: 'name' },
            { text: 'Icon', value: 'icon' },
            { text: '', value: 'modify', align: 'right', sortable: false }
          ],
          form: CategoryForm,
          table: '',
          delete: async (id) => {
            const response = await CategoriesService.deleteCategory(id)
            return response
          }
        },
        transitstops: {
          text: 'Transit Stops',
          icon: 'fa-bus',
          headers: [
            { text: 'Stop ID', value: 'stopId' },
            { text: 'Name', value: 'name' },
            { text: 'Campus', value: 'campus' },
            { text: '', value: 'modify', align: 'right', sortable: false }
          ],
          form: TransitStopForm,
          table: '',
          delete: async (id) => {
            const response = await TransitService.deleteTransitStop(id)
            return response
          }
        },
        campuses: {
          text: 'Campuses',
          icon: 'fa-bullseye',
          headers: [
            { text: 'Code', value: 'code' },
            { text: 'Name', value: 'name' },
            { text: 'Way', value: 'way' },
            { text: '', value: 'modify', align: 'right', sortable: false }
          ],
          form: CampusForm,
          table: '',
          delete: async (id) => {
            const response = await CampusesService.deleteCampus(id)
            return response
          }
        }
        // tours: {
        //   text: 'Tours',
        //   icon: 'fa-bullseye',
        //   headers: [
        //     { text: 'Title', value: 'title' },
        //     { text: '', value: 'modify', align: 'right', sortable: false }
        //   ],
        //   form: TourForm,
        //   table: '',
        //   delete: async (id) => {
        //     const response = await ToursService.deleteTour(id)
        //     return response
        //   }
        // }
      }
    }
  }
}
